import type { InteractionApiError } from '@/app/utils/auth-interactions-api';

export type AuthInteractionMode = 'login' | 'signup' | 'magic_link';

export type InternalInteractionMode =
  | AuthInteractionMode
  | 'magic_link_pending'
  | 'magic_link_consume';

export type InteractionCompletionMode = 'redirect' | 'embedded';

export const INTERACTION_TERMINAL_REASONS = {
  expired: 'expired',
} as const;
export type InteractionTerminalReason =
  (typeof INTERACTION_TERMINAL_REASONS)[keyof typeof INTERACTION_TERMINAL_REASONS];

export interface InteractionCompletion {
  mode: InteractionCompletionMode;
  complete: (resumeUrl: string) => void | Promise<void>;
}

export interface TerminalInteractionState {
  title: string;
  message: string;
  actionLabel?: string;
  actionVariant?: 'primary' | 'secondary';
  reason?: InteractionTerminalReason;
}

export interface InteractionTerminalHandler {
  (error: InteractionApiError | TerminalInteractionState): void;
}

export interface InteractionApprovedHandler {
  (resumeUrl: string): Promise<boolean>;
}
